module.exports = __webpack_public_path__ + "static/media/google_sheets_thumbnail.70e1e6b4.png";